///<reference path="../../../typings/angularjs/angular.d.ts"/>

module ProcessEditor {
    'use strict';
    export class TaskService {
        private availableTasks: ng.IDeferred<ITaskSelectionData[]>;
        private tasks: ITaskSelectionData[];

        constructor(private $http: ng.IHttpService, private $q: ng.IQService, private taskDataResourceUrl: string, private processService: ProcessService) {
            this.tasks = [];
        }

        public getAvailableTasks(): ng.IPromise<ITaskSelectionData[]> {
            if (!this.availableTasks) {
                this.availableTasks = this.$q.defer<ITaskSelectionData[]>();
                this.$http.get(this.taskDataResourceUrl).success((response:Frends.IJsonResponse) => {
                    if (response.success) {
                        var taskData = _.map(response.data, (d: ITaskDataResponse) => {
                            return {
                                name: d.name,
                                uri: d.uri,
                                packageName: d.packageName,
                                arguments: angular.fromJson(d.argumentsJson),
                                returnType: d.returnType,
                                description: d.description
                            }
                        });
                        this.tasks = _.chain(taskData).sortBy(t=> t.name.toLowerCase()).sortBy(t=> t.packageName.toLowerCase()).value();
                        this.availableTasks.resolve(this.tasks);
                    } else {
                        this.availableTasks.reject(response.errorMessage);
                    }
                }).error((error) => {
                        this.availableTasks.reject(error);
                });
            }
            return this.availableTasks.promise;
        }

        public getTaskParameters(newParameters: ITaskParameter[], oldParameters: ITaskParameter[]) {
            return _.map(newParameters, (newParam) => {
                let oldParam = _.find(oldParameters, (o) => o.name === newParam.name);
                return this.cloneParameterStructureFromMetaData(newParam, oldParam)
            });
        }

        public showObsoleteIcon(taskUri) {
            if (_.isEmpty(this.tasks)) {
                return false;
            }
            let match = _.find(this.tasks, (t: ITaskSelectionData) => t.uri === taskUri);
            return (match === undefined && !this.processService.currentProcess.isNotLatestVersion);
        }

        private cloneParameterStructureFromMetaData(newParameterData: ITaskParameter, oldParameterData: ITaskParameter = null): ITaskParameter {
            var value = this.getInitialValue(newParameterData);
            var oldSubParameters = [];

            if (oldParameterData != null && newParameterData.name === oldParameterData.name && newParameterData.type === oldParameterData.type) {
                // this parameter matches the oldParameterData structure, use values from it
                value = oldParameterData.value;
                oldSubParameters = oldParameterData.subParameters;
            }

            /*Recursively set initial values to all subParameters*/
            let subParameters = [];
            if(newParameterData.parameterType == "ArrayParameter") {
                subParameters = _.map(oldSubParameters, oldParameter => this.cloneParameterStructureFromMetaData(newParameterData.parameterTemplate, oldParameter));
            } else if(newParameterData.subParameters) {
                subParameters = this.getTaskParameters(newParameterData.subParameters, oldSubParameters);
            }

            /*Set initial value for parameter template, and also recursively set inital values to all subparameters in the template*/
            let parameterTemplate = newParameterData.parameterTemplate ? this.cloneParameterStructureFromMetaData(newParameterData.parameterTemplate) : null;

            return {
                name: newParameterData.name,
                type: newParameterData.type,
                inputType: newParameterData.inputType,
                description: newParameterData.description,
                defaultValue: newParameterData.defaultValue,
                value: value,
                parameterType: newParameterData.parameterType,
                parameterTemplate: parameterTemplate,
                subParameters: subParameters,
                isSecret: newParameterData.isSecret,
                minimum: newParameterData.minimum,
                maximum: newParameterData.maximum,
                regex: newParameterData.regex
            }
        }

        private getInitialValue(parameter) {
            if (parameter.defaultValue != null) {
                return parameter.defaultValue.toString();
            }

            if (parameter.parameterType === "TextParameter") {
                if (parameter.inputType === "text") {
                    return "\"\"";
                } else if (parameter.inputType === "number") {
                    return "0";
                } else {
                    return "";
                }
            } else if (parameter.parameterType === "EnumParameter") {
                return parameter.subParameters[0].name;
            } else if (parameter.parameterType === "BooleanParameter") {
                return "false";
            } else {
                return "";
            }
        }
    }

    app.service("TaskService", ["$http", "$q", "taskDataResourceUrl", "ProcessService", TaskService]);

    interface ITaskDataResponse {
        name: string;
        uri: string;
        packageName: string;
        argumentsJson: string;
        returnType: string;
        description: string;
    }
}